import React from "react";
import classes from "./ToolboxButton.module.scss";
import {
  BiSolidRightArrowAlt,
  BiSolidLeftArrowAlt,
  BiSolidDownArrowAlt,
} from "react-icons/bi";
import { MdCancel } from "react-icons/md";
import { MdSettingsBackupRestore, MdDateRange } from "react-icons/md";
import { IoMdAdd, IoMdRemoveCircle } from "react-icons/io";
import { FaTrowelBricks } from "react-icons/fa6";
import { LuPrinter, LuSearch } from "react-icons/lu";
import { FaRegCopy } from "react-icons/fa";
import { FiBarChart } from "react-icons/fi";
import { TiDocumentText } from "react-icons/ti";
import { GiHamburgerMenu, GiConcreteBag } from "react-icons/gi";
import { TiDelete } from "react-icons/ti";
import InfoTooltip from "components/Popup/InfoTooltip";

export enum ToolboxButtonIcon {
  Back = "Back",
  Forward = "Forward",
  Search = "Search",
  CancelSearch = "CancelSearch",
  TinyCancelSearch = "TinyCancelSearch",
  Restore = "Restore",
  Print = "Print",
  Add = "Add",
  Copy = "Copy",
  RemoveCircle = "RemoveCircle",
  ArrowCircleDown = "ArrowCircleDown",
  DateRange = "DateRange",
  Chart = "Chart",
  DocumentText = "DocumentText",
  Hamburger = "Hamburger",
  Brick = "Brick",
  Concrete = "Concrete",
  Delete = "Delete",
}

interface IProps {
  icon: string;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  tiny?: boolean;
  tooltip?: string;
  toolbox?: boolean;
  submitButton?: boolean;
  noCircle?: boolean;
}

const ToolboxButton = (props: IProps) => {

  const getIcon = () => {
    switch (props.icon) {
      case ToolboxButtonIcon.Back:
        return <BiSolidLeftArrowAlt className={classes.fas} size={25} />;
      case ToolboxButtonIcon.Forward:
        return <BiSolidRightArrowAlt className={classes.fas} size={25} />;
      case ToolboxButtonIcon.Search:
        return <LuSearch className={classes.fas} size={18} strokeWidth={2.5} />;
      case ToolboxButtonIcon.CancelSearch:
        return <MdCancel color="#BA306D" className={classes.fas} />;
      case ToolboxButtonIcon.Restore:
        return <MdSettingsBackupRestore className={classes.fas} />;
      case ToolboxButtonIcon.Print:
        return <LuPrinter className={classes.fas} />;
      case ToolboxButtonIcon.Add:
        return <IoMdAdd className={classes.fas} size={21} strokeWidth={10} />;
      case ToolboxButtonIcon.RemoveCircle:
        return <IoMdRemoveCircle className={classes.fas} />;
      case ToolboxButtonIcon.Copy:
        return <FaRegCopy className={classes.fas} />;
      case ToolboxButtonIcon.ArrowCircleDown:
        return <BiSolidDownArrowAlt className={classes.fas} size={25} />;
      case ToolboxButtonIcon.DateRange:
        return <MdDateRange className={classes.fas} />;
      case ToolboxButtonIcon.Chart:
        return <FiBarChart className={classes.fas} />;
      case ToolboxButtonIcon.DocumentText:
        return <TiDocumentText className={classes.fas} size={20} />;
      case ToolboxButtonIcon.Hamburger:
        return <GiHamburgerMenu className={classes.fas} />
      case ToolboxButtonIcon.Brick:
        return <FaTrowelBricks className={classes.fas} />
      case ToolboxButtonIcon.Concrete:
        return <GiConcreteBag className={classes.fas} />
      case ToolboxButtonIcon.Delete:
        return <TiDelete className={classes.fas} />
      default:
        return null;
    }
  }

  const className = props.tiny === true ? classes.tinyIconItem : classes.iconItem;
  const classNameWithDisabled = props.onClick !== undefined ? className : `${className} ${classes.disabledIcon}`;
  const classNameWithDisabledAndToolbox = props.toolbox === true ? `${classNameWithDisabled} ${classes.toolbox}` : classNameWithDisabled;
  const classNameWithDisabledToolboxAndNoCircle = props.noCircle === true
    ? `${classNameWithDisabledAndToolbox} ${classes.noCircle}`
    : classNameWithDisabledAndToolbox;

  if (props.tooltip !== undefined) {
    return (
      <InfoTooltip
        tooltip={props.tooltip}
        classesProp={classNameWithDisabledToolboxAndNoCircle}
        onClick={props.onClick}
        element={props.submitButton === true ? "submit" : "span"}
      >
        {getIcon()}
      </InfoTooltip>
    );
  } else {
    if (props.submitButton === true) {
      return (
        <button
          type="submit"
          className={classNameWithDisabledToolboxAndNoCircle}
          onClick={props.onClick}
        >
          {getIcon()}
        </button>
      );
    } else {
      return (
        <span
          className={classNameWithDisabledToolboxAndNoCircle}
          onClick={props.onClick}
        >
          {getIcon()}
        </span>
      );
    }
  }
};

export default ToolboxButton;
